<ng-container [formGroupName]="groupIndex">
  <div class="mandatory font-body-1 dark-grey flex flex--end">{{ 'paxDetails.mandatory' | finLocalization }}</div>
  <ng-container *ngIf="passengerFormGroup.contains(FIELDS.gender)">
    <div
      class="title font-body-1 bold-type nordic-blue-900 pr-xsmall-t"
      [ngClass]="{
        'error-900-text': passengerFormGroup.get(FIELDS.gender).invalid && passengerFormGroup.get(FIELDS.gender).touched
      }"
    >
      <span> {{ 'paxDetails.fields.gender.label' | finLocalization }} * </span>
      <ng-template #contentTooltip>
        <h2 class="font-body-1 bold-type nordic-blue-900-text">
          {{ 'paxDetails.fields.gender.tooltipHeading' | finLocalization }}
        </h2>
        <p class="pr-xxsmall-t nordic-blue-400-text regular-type">
          {{ 'paxDetails.fields.gender.tooltipContent' | finLocalization }}
        </p>
      </ng-template>
      <button
        type="button"
        fcomTooltip
        [options]="{ closeOnScroll: true }"
        [content]="contentTooltip"
        [ariaCloseText]="'actions.close' | finLocalization"
        [attr.aria-label]="'actions.info' | finLocalization"
        class="icon ms-xxsmall-l"
        [ngClass]="
          passengerFormGroup.get(FIELDS.gender).invalid && passengerFormGroup.get(FIELDS.gender).touched
            ? 'error-900-text'
            : 'nordic-blue-900-text'
        "
      >
        <fcom-icon name="help-block" class="is-xsmall"></fcom-icon>
      </button>
    </div>
    <div class="gender pr-xxsmall-b font-body-1 flex">
      <fin-radio-item
        *ngFor="let value of GENDER_OPTIONS"
        class="mr-small-r"
        [controlName]="FIELDS.gender"
        [translationPrefix]="'paxDetails.fields.gender'"
        [parentForm]="passengerFormGroup"
        [radioKey]="value"
        [id]="'gender-' + value + '-' + groupIndex"
        [name]="'gender-' + groupIndex"
      >
      </fin-radio-item>
    </div>
    <div
      *ngIf="passengerFormGroup.get(FIELDS.gender).invalid && passengerFormGroup.get(FIELDS.gender).touched"
      class="gender-error-label font-body-2"
      aria-live="polite"
    >
      <span *ngIf="passengerFormGroup.get(FIELDS.gender).errors?.required" class="error-900-text">
        {{ 'paxDetails.fields.' + FIELDS.gender + '.required' | finLocalization }}
      </span>
    </div>
  </ng-container>

  <div class="flex name-wrapper">
    <fcom-text-input
      *ngFor="let inputName of [FIELDS.firstName, FIELDS.lastName]"
      class="input-name block ms-small-t flex-1 flex--basis0"
      [required]="true"
      [parentForm]="passengerFormGroup"
      [displayMargin]="false"
      [translationPrefix]="'paxDetails.fields.' + inputName"
      [controlName]="inputName"
      [id]="inputName + '-' + groupIndex"
      [placeHolder]="'paxDetails.fields.' + inputName + '.placeholder'"
      [displayMargin]="false"
      [attr.data-test-id]="inputName + '-' + groupIndex"
      [tooltipHeading]="'paxDetails.fields.' + inputName + '.tooltipHeading' | finLocalization"
      [tooltipContent]="'paxDetails.fields.' + inputName + '.tooltipContent' | finLocalization"
    ></fcom-text-input>
  </div>

  <ng-template #emailAndPhoneNumber>
    <fcom-text-input
      data-test-email
      *ngIf="passengerFormGroup.get(FIELDS.type).value !== FinnairPassengerCode.INF"
      class="block ms-small-t flex-1"
      [parentForm]="passengerFormGroup"
      [displayMargin]="false"
      [translationPrefix]="'paxDetails.fields.email'"
      [controlName]="FIELDS.email"
      [id]="'email-' + groupIndex"
      [placeHolder]="'paxDetails.fields.email.placeholder'"
      [displayMargin]="false"
    ></fcom-text-input>

    <fin-form-array
      data-test-phones
      *ngIf="
        passengerFormGroup.get(FIELDS.phones) && passengerFormGroup.get(FIELDS.type).value !== FinnairPassengerCode.INF
      "
      [parentForm]="passengerFormGroup"
      [controlName]="'phones'"
      [translationPrefix]="'paxDetails.fields.phones'"
      [displayLabels]="false"
      [minGroups]="1"
      [maxGroups]="3"
      [displayContainerStyles]="false"
      [compressedList]="true"
      [formGroupConfig]="phoneNumbersGroupConfig"
      [formGroupOptions]="phoneGroupOptions"
    >
      <ng-template let-otherPhone="parentFormGroup" let-index="index">
        <fin-form-group
          class="block field wd-phone ms-small-t"
          [group]="otherPhone"
          [translationPrefix]="'paxDetails.fields'"
          [attr.data-index]="index"
          [names]="[FIELDS.phonePrefix, FIELDS.phoneNumber]"
          [showOnlyGroupLevelErrors]="true"
        >
          <div class="phone-wrapper flex">
            <fin-select-input
              class="input-phone flex-1 flex--basis0"
              [controlName]="FIELDS.phonePrefix"
              [id]="'tel-country-code-' + groupIndex"
              [translationPrefix]="'paxDetails.fields.phonePrefix'"
              [parentForm]="otherPhone"
              [displayMargin]="false"
              [options]="phonePrefixes$ | async"
            >
            </fin-select-input>
            <fcom-text-input
              class="flex-1 flex--basis0"
              [translationPrefix]="'paxDetails.fields.phoneNumber'"
              [controlName]="FIELDS.phoneNumber"
              [id]="'tel-national-' + groupIndex"
              [parentForm]="otherPhone"
              [displayMargin]="false"
              [placeHolder]="'paxDetails.fields.phoneNumber.placeholder'"
            >
            </fcom-text-input>
          </div>
        </fin-form-group>
      </ng-template>
    </fin-form-array>

    <fin-form-group
      data-test-phone
      *ngIf="
        passengerFormGroup.get(FIELDS.phone) && passengerFormGroup.get(FIELDS.type).value !== FinnairPassengerCode.INF
      "
      class="block field wd-phone"
      [group]="passengerFormGroup.get(FIELDS.phone)"
      [translationPrefix]="'paxDetails.fields'"
      [names]="[FIELDS.phonePrefix, FIELDS.phoneNumber]"
      [showOnlyGroupLevelErrors]="true"
    >
      <div class="phone-wrapper flex">
        <fin-select-input
          class="input-phone flex-1 flex--basis0 ms-small-t"
          [controlName]="FIELDS.phonePrefix"
          [id]="'tel-country-code-' + groupIndex"
          [translationPrefix]="'paxDetails.fields.phonePrefix'"
          [parentForm]="passengerFormGroup.get(FIELDS.phone)"
          [displayMargin]="false"
          [options]="phonePrefixes$ | async"
          [required]="isMainPassenger"
          [attr.aria-required]="isMainPassenger"
          [selectLabelTranslationKey]="'paxDetails.fields.phonePrefix.placeholder'"
        >
        </fin-select-input>

        <fcom-text-input
          class="flex-1 flex--basis0 ms-small-t"
          [controlName]="FIELDS.phoneNumber"
          [id]="'tel-national-' + groupIndex"
          [translationPrefix]="'paxDetails.fields.phoneNumber'"
          [parentForm]="passengerFormGroup.get(FIELDS.phone)"
          [displayMargin]="false"
          [required]="isMainPassenger"
          [placeHolder]="'paxDetails.fields.phoneNumber.placeholder'"
          (inputEvent)="removeLeadingZero($event)"
        >
        </fcom-text-input>
      </div>
      <cms-unstyled-fragment
        *ngIf="'fragments.optOutTelephoneSolicitation.url' | finLocalization"
        class="block font-body-1 mr-large-t"
        [contentUrl$]="'fragments.optOutTelephoneSolicitation.url' | finLocalization | finToObservable"
      >
      </cms-unstyled-fragment>
    </fin-form-group>
  </ng-template>

  <fin-form-group
    *ngIf="passengerFormGroup.get(FIELDS.birthDate) !== null"
    class="block field wd-birthDay pr-xsmall-y"
    [group]="passengerFormGroup.get(FIELDS.birthDate)"
    [translationPrefix]="'paxDetails.fields'"
    [groupTranslationPrefix]="'paxDetails.fields.birthDate'"
    [required]="true"
    [names]="[FIELDS.dateOfBirth, FIELDS.monthOfBirth, FIELDS.yearOfBirth]"
    [showOnlyGroupLevelErrors]="true"
  >
    <div class="title font-body-1 nordic-blue-900">
      {{ 'paxDetails.dateOfBirthLabel' | finLocalization }}
    </div>
    <div class="birthday-wrapper flex">
      <fin-select-input
        class="bday-day flex-1 flex--basis0 ms-small-t"
        data-field="bday-day"
        [controlName]="FIELDS.dateOfBirth"
        [id]="'bday-day-' + groupIndex"
        [translationPrefix]="'paxDetails.fields.dateOfBirth'"
        [parentForm]="passengerFormGroup.get(FIELDS.birthDate)"
        [displayMargin]="false"
        [options]="dayOptions$ | async"
      >
      </fin-select-input>

      <fin-select-input
        class="bday-month flex-1 flex--basis0 ms-small-t"
        data-field="bday-month"
        [controlName]="FIELDS.monthOfBirth"
        [id]="'bday-month-' + groupIndex"
        [translationPrefix]="'paxDetails.fields.monthOfBirth'"
        [parentForm]="passengerFormGroup.get(FIELDS.birthDate)"
        [displayMargin]="false"
        [options]="monthOptions"
      >
      </fin-select-input>

      <fin-select-input
        class="flex-1 flex--basis0 ms-small-t"
        data-field="bday-year"
        [controlName]="FIELDS.yearOfBirth"
        [id]="'bday-year-' + groupIndex"
        [translationPrefix]="'paxDetails.fields.yearOfBirth'"
        [parentForm]="passengerFormGroup.get(FIELDS.birthDate)"
        [displayMargin]="false"
        [options]="yearOptions"
      >
      </fin-select-input>
    </div>
  </fin-form-group>

  <ng-container *ngIf="!isMainPassenger && passengerFormGroup.get(FIELDS.type).value !== FinnairPassengerCode.INF">
    <fcom-button
      *ngIf="!showContactDetails"
      data-test-contact-details-button
      [theme]="ButtonTheme.TERTIARY"
      [text]="'paxDetails.addContactDetails.title' | finLocalization"
      [icon]="{ category: 'svg-library', name: 'plus-outline', position: IconPosition.LEFT }"
      [type]="ButtonType.BUTTON"
      [size]="ButtonSize.S_MEDIUM"
      (click)="showContactDetailsFields()"
      [attr.aria-label]="'paxDetails.addContactDetails.description' | finLocalization"
    ></fcom-button>
  </ng-container>

  <ng-container *ngIf="showContactDetails || isMainPassenger">
    <ng-container *ngTemplateOutlet="emailAndPhoneNumber"></ng-container>
  </ng-container>

  <ng-container *ngIf="!allowMultipleFFCards; else multipleCards">
    <ng-container *ngIf="passengerFormGroup.get(FIELDS.frequentFlyerCard) !== null">
      <div class="title font-body-1 bold-type nordic-blue-900 pr-xsmall-t">
        {{ 'paxDetails.frequentFlyerSection.title' | finLocalization }}
      </div>

      <fin-form-group
        class="block frequent-flyer field pr-xsmall-y"
        [group]="passengerFormGroup.get(FIELDS.frequentFlyerCard)"
        [translationPrefix]="'paxDetails.fields'"
        [groupTranslationPrefix]="'paxDetails.fields.cardNumber'"
        [required]="false"
        [names]="[FIELDS.companyCode, FIELDS.cardNumber]"
        [showOnlyGroupLevelErrors]="true"
      >
        <fcom-checkbox
          class="ms-large-b"
          [theme]="CheckBoxTheme.ROUNDED"
          [name]="'frequent-flyer-checkbox'"
          [checked]="frequentFlyerIsOpen$ | async"
          (change)="toggleFrequentFlyerSection($event)"
        >
          <div class="flex flex--column">
            <span class="flex flex--column font-body-1 medium-type privatedata data-hj-suppress">
              {{ 'paxDetails.fields.frequentFlyerCard.title' | finLocalization }}
            </span>
            <span
              class="font-body-2 light-type grey-600-text privatedata data-hj-suppress"
              *ngIf="(frequentFlyerIsOpen$ | async) === false"
            >
              {{ 'paxDetails.fields.frequentFlyerCard.label' | finLocalization }}
            </span>
          </div>
        </fcom-checkbox>
        <div class="frequent-flyer-wrapper flex" *ngIf="(frequentFlyerIsOpen$ | async) === true">
          <fin-select-input
            class="frequent-flyer-airline flex-1 flex--basis0 ms-small-t"
            [translationPrefix]="'paxDetails.fields.companyCode'"
            [controlName]="FIELDS.companyCode"
            [id]="'frequent-flyer-airline-' + groupIndex"
            [parentForm]="passengerFormGroup.get(FIELDS.frequentFlyerCard)"
            [displayMargin]="false"
            [options]="frequentFlyerAirlines$ | async"
            [selectLabelTranslationKey]="'paxDetails.fields.companyCode.placeholder'"
          >
          </fin-select-input>
          <fcom-text-input
            class="flex-1 flex--basis0 ms-small-t"
            [translationPrefix]="'paxDetails.fields.cardNumber'"
            [controlName]="FIELDS.cardNumber"
            [id]="'frequent-flyer-number-' + groupIndex"
            [parentForm]="passengerFormGroup.get(FIELDS.frequentFlyerCard)"
            [displayMargin]="false"
            [finElemTracker]="'frequent-flyer-number'"
            [finElemType]="ElementTypes.INPUT"
            [finElemContext]="trackingContext + '_pax-details'"
            [placeHolder]="'paxDetails.fields.cardNumber.placeholder'"
          >
          </fcom-text-input>
        </div>
      </fin-form-group>
      <ng-container
        #joinFinnairPlus
        *ngIf="isMainPassenger && (profileType$ | async) === undefined"
        [formGroup]="passengerFormGroup"
      >
        <fcom-checkbox
          class="ms-large-y"
          [theme]="CheckBoxTheme.ROUNDED"
          [name]="FIELDS.joinFinnairPlus"
          [formControlName]="FIELDS.joinFinnairPlus"
          data-test-fplus
          [finElemTracker]="'join-finnair-plus'"
          [finElemContext]="'booking-flow_pax-details'"
          [finElemType]="C.ElementTypes.CHECKBOX"
          (change)="toggleJoinFinnairPlus()"
        >
          <div class="flex flex--column">
            <span class="font-body-1 medium-type privatedata data-hj-suppress">
              {{ 'paxDetails.fields.joinFinnairPlus.title' | finLocalization }}
            </span>
            <span class="font-body-2 light-type grey-600-text privatedata data-hj-suppress">
              {{ 'paxDetails.fields.joinFinnairPlus.label' | finLocalization }}
            </span>
          </div>
        </fcom-checkbox>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #multipleCards>
    <h3 class="font-body-1 nordic-blue-900-text mr-small-t">
      {{ 'paxDetails.frequentFlyerDetails' | finLocalization }}
    </h3>
    <p class="mr-xsmall-t mr-xsmall-b">{{ 'paxDetails.frequentFlyerHelp' | finLocalization }}</p>
    <fin-form-array
      [parentForm]="passengerFormGroup"
      [controlName]="'frequentFlyerCards'"
      [translationPrefix]="'paxDetails.fields.frequentFlyerCards'"
      [displayLabels]="false"
      [minGroups]="1"
      [maxGroups]="3"
      [displayContainerStyles]="false"
      [compressedList]="true"
      [disabled]="passengerFormGroup.get(FIELDS.frequentFlyerCards).disabled"
      [formGroupConfig]="frequentFlyerGroupConfig"
      [formGroupOptions]="frequentFlyerGroupOptions"
    >
      <ng-template let-otherCard="parentFormGroup" let-index="index">
        <fin-form-group
          class="block frequent-flyer-multiple field pr-xsmall-b"
          [attr.data-index]="index"
          [group]="otherCard"
          [translationPrefix]="'paxDetails.fields'"
          [groupTranslationPrefix]="'paxDetails.fields.cardNumber'"
          [required]="false"
          [names]="[FIELDS.companyCode, FIELDS.cardNumber]"
          [showOnlyGroupLevelErrors]="true"
        >
          <div class="frequent-flyer-wrapper flex">
            <fin-select-input
              class="frequent-flyer-airline flex-1 flex--basis0 ms-small-t"
              [translationPrefix]="'paxDetails.fields.companyCode'"
              [controlName]="FIELDS.companyCode"
              [id]="'frequent-flyer-airline-' + groupIndex"
              [parentForm]="otherCard"
              [displayMargin]="false"
              [options]="frequentFlyerCardOptions$ | finMap: '' + index | async"
            >
            </fin-select-input>
            <fcom-text-input
              class="flex-1 flex--basis0 ms-small-t"
              [translationPrefix]="'paxDetails.fields.cardNumber'"
              [controlName]="FIELDS.cardNumber"
              [id]="'frequent-flyer-number-' + groupIndex"
              [parentForm]="otherCard"
              [displayMargin]="false"
              [finElemTracker]="'frequent-flyer-number'"
              [finElemType]="ElementTypes.INPUT"
              [finElemContext]="trackingContext + '_pax-details'"
            >
            </fcom-text-input>
          </div>
        </fin-form-group>
      </ng-template>
    </fin-form-array>
  </ng-template>
</ng-container>
